export const projectLeadRequiredPermissions = [
  'READ_PROJECT',
  'LIST_PROJECTS',
  'UPDATE_PROJECT',
  'UPDATE_PROJECT_STATUS',
  'UPDATE_PROJECT_SOURCE',
  'LIST_PROJECT_TEAM',
  'ADD_PROJECT_TEAM',
  'DELETE_PROJECT_TEAM',
  'LIST_PROJECT_SCHEDULE',
  'ADD_PROJECT_SCHEDULE',
  'UPDATE_PROJECT_SCHEDULE',
  'DELETE_PROJECT_SCHEDULE',
  'ADD_PROJECT_ASSETS',
  'LIST_PROJECT_ASSETS',
  'DELETE_PROJECT_ASSETS',
  'UPLOAD_PROJECT_THUMBNAIL',
];

export const projectTypeWithUnits = [
  'Affordable Homeownership',
  'Affordable Multi-Family',
  'Market Multi-Family',
  'Market-Rate Homeownership',
  'Workforce Housing',
  'Mixed-Use',
  'Hospitality',
];

export const projectTypeWithAvgSalesPrice = ['Affordable Homeownership', 'Market-Rate Homeownership'];
